
import { UpdateAccessCompanyModel } from "./../../../model/jubili/company-manage/update-access-company.model";
import { CompanyManageService } from "./../../../service/api/jubili/company-manage.service";
import { DatetimeModal } from "./../../../model/jubili/common/datetime-modal";
import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { FormControl, FormGroup } from "@angular/forms";
import { LocalStorageService } from "angular-2-local-storage";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../../service/api/auth/auth.service";

@Component({
  selector: "bo-jubili-edit-expire-company",
  templateUrl: "./jubili-edit-expire-company.component.html",
  styleUrls: ["./jubili-edit-expire-company.component.css"]
})
export class JubiliEditExpireCompanyComponent implements OnInit {

  private ngbModalRef: NgbModalRef;
  countDay: FormControl = new FormControl();
  formGroup: FormGroup = new FormGroup({
    countDay: this.countDay
  });
  center: any;
  constructor(
    private modalService: NgbModal,
    private companyManageService: CompanyManageService,
    private AuthService: AuthenticationService,
    private localStorageService: LocalStorageService,
    private router: Router) {
    this.countDay.valueChanges.subscribe(res => {
      const dateConvert = new Date(this.tempExpireDate.getFullYear(), this.tempExpireDate.getMonth(), this.tempExpireDate.getDate());
      dateConvert.setDate(dateConvert.getDate() + (res !== null ? res : 0));
      this.expireDate = new Date(dateConvert.getFullYear(), dateConvert.getMonth(), dateConvert.getDate());
    });
  }
  @ViewChild("content") content: any;
  public expireDate = new Date(Date.now());
  public companySurrKey: number;
  public tempExpireDate = new Date(Date.now());
  @Output() update = new EventEmitter();

  public ngOnInit(): void {

  }
  public show(date: DatetimeModal, companySurrKey: number): void {
    this.expireDate = date.day !== 0 ? new Date(Date.UTC(date.year, date.month - 1, date.day)) : new Date();
    this.tempExpireDate = this.expireDate !== null ? this.expireDate : new Date(Date.now());
    this.companySurrKey = companySurrKey;
    this.ngbModalRef = this.modalService.open(this.content, { centered: true });
  }

  public hide(): void {
    this.ngbModalRef.close();
  }

  public updateExpire(): void {
    const data = new UpdateAccessCompanyModel();
    data.companySurrKey = this.companySurrKey;
    const dateTime = new DatetimeModal();
    dateTime.day = this.expireDate.getDate();
    dateTime.month = this.expireDate.getMonth() + 1;
    dateTime.year = this.expireDate.getFullYear();
    data.expireDate = dateTime;
    this.companyManageService.UpdateExpireDate(data)
    .subscribe(() => {
      this.update.emit();
    },
    err => {
      // unauthorized refresh token
      console.log("unauth");
      if (err.status === 401) {
          this.AuthService.refreshSessionToken()
          .subscribe(
              Response => {
                  // Update session
                  this.localStorageService.set("accessToken", Response.authenticationResult.accessToken);

                  this.localStorageService.set("expiresTime", (Date.now() / 1000) + Response.authenticationResult.expiresIn);
                  this.updateExpire();
              }
          );
      } else {
          this.router.navigate(["/home"]);
      }
  });
    this.hide();
  }
}
